import {Component} from '@angular/core';
import {BaseChartComponent} from '@rsp/shared/component/graph/base-chart.component';
import * as Highcharts from 'highcharts';
import {TenantsCommunityTotalDTO} from '@rsp/models/dto/tenants-community-totals.dto';
import {sumConsumption} from '@rsp/shared/util/util';

@Component({
  selector: 'rsp-community-autarkie-grad-chart',
  templateUrl: '../base-chart.component.html',
})

export class CommunityAutarkieGradChartComponent extends BaseChartComponent<TenantsCommunityTotalDTO> {

  constructor() {
    super();
  }

  render() {
    super.render();

    const sum: number = sumConsumption(this._data) + this._data.residualConsumption;

    this.chart.ref.update(({
      series: [{
        data: [
          {
            y: +(this._data.residualConsumption / sum * 100).toFixed(2)
          }, {
            y: +(this._data.bioConsumption / sum * 100).toFixed(2)
          }, {
            y: +(this._data.waterConsumption / sum * 100).toFixed(2)
          }, {
            y: +(this._data.pvConsumption / sum * 100).toFixed(2)
          }, {
            y: +(this._data.windConsumption / sum * 100).toFixed(2)
          }
        ]
      } as any]
    }));
  }

  protected hasData(): boolean {
    return super.hasData();
  }


  protected createChartOptions(): Highcharts.Options {
    return {
      chart: {
        type: 'pie',
        height: 300
      },
      exporting: {
        enabled: true,
        buttons: <any>{
          contextButton: {
            enabled: false
          }
        }
      },
      title: {
        text: ''
      },
      tooltip: {
        valueSuffix: ' %'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true,
          startAngle: 50
        }
      },
      credits: {
        enabled: false
      },

      series: [
        {
          type: 'pie',
          name: 'Anteil',
          data: [
            {
              name: 'Sonstiger Ökostrom',
              color: this.color3
            }, {
              name: 'Einspeisung Bio',
              color: this.color4
            }, {
              name: 'Einspeisung Wasser',
              color: this.color1
            }, {
              name: 'Einspeisung Solar',
              color: this.color2
            }, {
              name: 'Einspeisung Wind',
              color: this.color5
            }
          ]
        }
      ]
    };
  }
}
